module.exports = __webpack_public_path__ + "img/RORBPJR40067.64d6ca2e.png";